import * as React from 'react';
import './styles.css';
import { slide as Menu } from 'react-burger-menu';
import styled from 'styled-components';
import { ColorPalette } from '../../../constant';

interface MenuBurgerProps {
  children: any;
  isOpen: boolean;
  onStateChange: (any) => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: fixed;
  z-index: 30000;
  right: 40px;
  top: 50px;
  height: 52px;
  width: 52px;
  background-color: ${ColorPalette.DARK_BLUE_2};
  padding: 12px;
`;

function MenuBurger(props: MenuBurgerProps) {
  const { isOpen, children, onStateChange } = props;

  return (
    <Container>
      <Menu isOpen={isOpen} onStateChange={onStateChange}>
        {children}
      </Menu>
    </Container>
  );
}

export default MenuBurger;
